module.exports = "<div class=\"graph\" ng-if=\"$ctrl.data\">\n  <canvas class=\"chart chart-bar\"\n          chart-data=\"[$ctrl.data.data]\"\n          chart-series=\"['flight count']\"\n          chart-labels=\"$ctrl.data.labels\"\n          chart-options=\"$ctrl.options\"\n          chart-click=\"$ctrl.fn\">\n  </canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/histogram/histogram.html
// module id = 438
// module chunks = 0